webpackJsonp([177411569968764],{

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipse"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsa"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsius"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsi"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ipso"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ipsa"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ipso"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsi"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsa"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsorum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsarum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsorum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsos"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsas"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsa"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ipsis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ipsis"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ipsis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "zelf"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Het rijtje van ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "ipse"
	        ),
	        " gaat hetzelfde als het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "aanwijzend-naamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "iste"
	          )
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "idem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eadem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "idem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eiusdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eiusdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eiusdem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eidem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eidem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eidem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eundem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eandem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "idem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eodem"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eadem"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eodem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eidem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eaedem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eadem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eorundem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "earundem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eorundem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eisdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eisdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eisdem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eosdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "easdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eadem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eisdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eisdem"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eisdem"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "dezelfde, hetzelfde"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Het rijtje van ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "idem"
	        ),
	        " gaat hetzelfde als het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "verwijzend-naamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "is"
	          )
	        ),
	        " ",
	        "met ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "-dem"
	        ),
	        " erachter. Als de vorm van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "verwijzend-naamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "is"
	          )
	        ),
	        " ",
	        "op een ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "-m"
	        ),
	        " eindigt, wordt het een ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "-n"
	        ),
	        "."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _bepVnw = __webpack_require__(642);
	
	var _bepVnw2 = _interopRequireDefault(_bepVnw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "40",
	  table: _bepVnw2.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "40",
	    data: data,
	    title: "Bepalend voornaamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-bepalend-voornaamwoord-js-3aadd9d24450efcde8c8.js